module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-pachet-contructor.3b339323.jpg";